import {
  pgTable,
  uuid,
  text,
  boolean,
  integer,
  numeric,
  timestamp,
  index,
} from "drizzle-orm/pg-core";

export const coupons = pgTable(
  "coupons",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    code: text("code").notNull().unique(),
    type: text("type")
      .notNull()
      .$type<"percentage" | "fixed_amount" | "free_shipping">(),
    value: numeric("value", { precision: 12, scale: 2 }).notNull(),
    minOrderValue: numeric("min_order_value", { precision: 12, scale: 2 }),
    usageLimit: integer("usage_limit"),
    usageCount: integer("usage_count").notNull().default(0),
    perCustomerLimit: integer("per_customer_limit"),
    startDate: timestamp("start_date", { withTimezone: true }),
    endDate: timestamp("end_date", { withTimezone: true }),
    customerGroupIds: uuid("customer_group_ids").array(),
    categoryIds: uuid("category_ids").array(),
    isActive: boolean("is_active").notNull().default(true),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    codeIdx: index("coupons_code_idx").on(t.code),
    activeIdx: index("coupons_is_active_idx").on(t.isActive),
  })
);

export type Coupon = typeof coupons.$inferSelect;
export type NewCoupon = typeof coupons.$inferInsert;

export const COUPON_TYPES = ["percentage", "fixed_amount", "free_shipping"] as const;
export type CouponType = (typeof COUPON_TYPES)[number];
